/**
 * Manual do usuário em PDF (#295)
 *
 * O arquivo é copiado de docs/manual no build do painel (ver vite.config.ts), então
 * o manual baixado é sempre o da versão publicada.
 *
 * @author Equipe VendeAi
 * @since 1.9.0
 */

/** Endereço do PDF ('' quando o build não encontrou o arquivo) */
export const USER_MANUAL_URL = import.meta.env.VITE_USER_MANUAL_SIZE_MB
  ? import.meta.env.VITE_USER_MANUAL_URL
  : '';

/** Texto de apoio com o tamanho do arquivo, ex.: "PDF, 26 MB" */
export const USER_MANUAL_HINT = import.meta.env.VITE_USER_MANUAL_SIZE_MB
  ? `PDF, ${import.meta.env.VITE_USER_MANUAL_SIZE_MB} MB`
  : 'PDF';
